import React from 'react';

import { ReactComponent as Logo } from '../../assets/svg/logo-camera.svg';

const LoadingPage = () => (
  <main className="loading-page">
    <Logo />
  </main>
);

export default LoadingPage;
